module.exports = __webpack_public_path__ + "media/images/sanitary-img-2-c0ec38bc1031e11ec7baf3d31b5f8d72.jpg";